import { useContext, useEffect } from "react";
import { useHistory } from "react-router";
import { LocationContext } from "../../App";
import { bookAppointmentUrl } from "../../constants/routes";
import "./ServicePageV2.scss";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";

const ServicePageV2 = () => {
  const {
    location: { pathname },
  } = useHistory();

  const [, setLocation] = useContext(LocationContext);

  useEffect(() => {
    setLocation(pathname);
  }, [setLocation, pathname]);

  return (
    <div className="servicePageV2">
      <div className="header">
        <h1>Service Prices</h1>

        <span className="headerActions">
          <button onClick={() => window.open(bookAppointmentUrl, "_blank")}>
            BOOK APPOINTMENT
          </button>

          <FaInfoCircle
            id="cancelationTooltipPricing"
            className="infoIcon"
            size={26}
          />

          <Tooltip
            anchorSelect="#cancelationTooltipPricing"
            style={{ width: "280px", zIndex: 99 }}
            content={
              <div>
                <h3>Cancelation / No show policy</h3>
                <p>
                  Your treatment is reserved especially for YOU. At
                  “Electrolysis by AK” we value your business and understand that
                  scheduling changes may occur. We respectfully request 24 hour
                  notice for any cancellations or rescheduling. Less than 24
                  hours notice will result in a fee of 50% of the scheduled
                  appointment time. Late arrival or early termination of service
                  is not pro-rated.
                </p>
                <h4>Payments are due at the time of treatment.</h4>
              </div>
            }
          />
        </span>
      </div>

      <div className="container">
        {/* Consultation */}
        <div className="row consultation-row">
          <div className="label">Consultation</div>
          <div className="price free">FREE</div>
        </div>
        <div className="divider" />

        {/* Time based pricing */}
        <div className="row">
          <div className="borderedCircle">
            <i className="time">
              15 <i className="min-fee">min</i>
            </i>
            <i className="min-fee">or less</i>
          </div>
          <div className="price">$50</div>
        </div>
        <div className="divider" />

        <div className="row">
          <div className="borderedCircle">
            <i className="time">20</i> <i>min</i>
          </div>
          <div className="price">$60</div>
        </div>
        <div className="divider" />

        <div className="row">
          <div className="borderedCircle">
            <i className="time">30</i> <i>min</i>
          </div>
          <div className="price">$75</div>
        </div>
        <div className="divider" />

        <div className="row">
          <div className="borderedCircle">
            <i className="time">45</i> <i>min</i>
          </div>
          <div className="price">$120</div>
        </div>
        <div className="divider" />

        <div className="row">
          <div className="borderedCircle">
            <i className="time">60</i> <i>min</i>
          </div>
          <div className="price">$150</div>
        </div>
        <div className="divider" />

        {/* Bikini */}
        <div className="row bikini-row">
          <div className="label">Bikini area</div>
          <div className="price bikini-price">$180 - $200</div>
        </div>
        <div className="divider" />

        {/* Multi-needle section */}
        <div className="price-section">
          <div className="section-title">Multi-needle electrolysis</div>

          <div className="row">
            <div className="borderedCircle">
              <i className="time">45</i> <i>min</i>
            </div>
            <div className="price">$170</div>
          </div>
          <div className="divider" />

          <div className="row">
            <div className="borderedCircle">
              <i className="time">60</i> <i>min</i>
            </div>
            <div className="price">$200</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicePageV2;
